import { gql, TypedDocumentNode } from "@apollo/client";

import {
  BitbucketDatacenterIntegration,
  QueryBitbucketDatacenterIntegrationArgs,
} from "types/generated";

type GetVCSBitbucketDataCenterIntegrationQuery = {
  bitbucketDatacenterIntegration: Pick<
    BitbucketDatacenterIntegration,
    | "vcsChecks"
    | "apiHost"
    | "description"
    | "id"
    | "isDefault"
    | "labels"
    | "name"
    | "space"
    | "userFacingHost"
    | "username"
    | "useGitCheckout"
    | "webhookSecret"
    | "webhookURL"
  >;
};

export const GET_BITBUCKET_DATA_CENTER_INTEGRATION: TypedDocumentNode<
  GetVCSBitbucketDataCenterIntegrationQuery,
  QueryBitbucketDatacenterIntegrationArgs
> = gql`
  query GetVCSBitbucketDataCenterIntegration($id: ID!) {
    bitbucketDatacenterIntegration(id: $id) {
      vcsChecks
      useGitCheckout
      apiHost
      description
      id
      isDefault
      labels
      name
      space {
        id
        name
        accessLevel
      }
      userFacingHost
      username
      webhookSecret
    }
  }
`;
